export interface PayoutsRouteParams {
  date: string;
  stateFilter?: string;
  payoutConfigFilter?: string;
}

export enum PayoutReportsSearchKey {
  STATE_FILTER = 'stateFilter',
}

export enum PayoutWebsitesSearchKey {
  SEARCH = 'search',
}

export enum PayoutConfigsSearchKey {
  SEARCH = 'search',
}
